import { ehComprado, type CustoAquisicaoResponse } from '@triade/contracts';
import { ErroFormacao } from '@/components/formacao/avisos-formacao';
import { formatarData, formatarCusto } from '@/lib/format';
import type { ApiError } from '@/lib/api';
import type { TipoItem } from './tipos';

export interface HistoricoCustosItemProps {
  tipo: TipoItem;
  custos: CustoAquisicaoResponse[] | undefined;
  erro: ApiError | null;
  onTentar: () => void;
}

/** Aba "Historico de custos": todas as vigencias de custo de aquisicao (append-only), da mais recente para a mais antiga. */
export function HistoricoCustosItem({ tipo, custos, erro, onTentar }: HistoricoCustosItemProps) {
  if (erro) return <div className="p-5"><ErroFormacao erro={erro} onTentar={onTentar} /></div>;
  if (!custos) return <p role="status" className="p-5 text-small text-ink-muted">Carregando histórico de custos…</p>;
  if (custos.length === 0) {
    return (
      <p role="status" className="p-5 text-small text-ink-muted">
        {ehComprado(tipo) ? 'Nenhum custo de aquisição registrado ainda.' : 'Só itens comprados têm histórico de custo de aquisição. O custo deste item vem da ficha técnica.'}
      </p>
    );
  }
  return (
    <div className="overflow-x-auto p-5">
      <table data-testid="historico-custos" className="w-full min-w-[520px] border-collapse text-small">
        <thead>
          <tr className="text-left text-caption text-ink-muted">
            <th scope="col" className="py-2 pr-3 font-medium">Vigência</th>
            <th scope="col" className="px-3 py-2 text-right font-medium">Preço base</th>
            <th scope="col" className="py-2 pl-3 text-right font-medium">Custo de aquisição</th>
          </tr>
        </thead>
        <tbody>
          {custos.map((c) => (
            <tr key={c.id} className="border-t border-line-soft">
              <td className="tabular py-2.5 pr-3">
                {formatarData(c.validFrom)} {c.validTo ? `– ${formatarData(c.validTo)}` : <span className="rounded-full bg-success-bg px-2 py-0.5 text-caption font-semibold text-success-ink">vigente</span>}
              </td>
              <td className="tabular px-3 py-2.5 text-right">{formatarCusto(c.basePrice)}</td>
              <td className="tabular py-2.5 pl-3 text-right font-semibold">{formatarCusto(c.acquisitionCost)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
